import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { UserAuthData } from 'src/app/core/auth/authData.model';
import { python } from 'src/environments/environments';
import { Notifications } from '../interfaces/notification.interface';
import { NotificationsStateService } from './notifications-state.service';
import { WebsocketService } from './websocket.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  [x: string]: any;
  currentUser: UserAuthData | null = null;

  // private readonly ruta = `${env.url_base}${env.api}${env.crm}${env.api_end}`;
  private readonly ruta = ``; //${python.url_base}
  private readonly ruta_ws = ``; //${python.url_ws}

  private newNotificationSubject = new BehaviorSubject<boolean>(false);
  private notificationsSubject = new BehaviorSubject<Notifications[]>([]);

  newNotification$ = this.newNotificationSubject.asObservable();
  notifications$ = this.notificationsSubject.asObservable();

  private userAuthStatusSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private websocketService: WebsocketService,
    private authService: AuthService,
    private notificationsStateService: NotificationsStateService
  ) {
    this.authService.currentUser$.subscribe((user) => {
      if (user) {
        // Si hay usuario, indica que el usuario está autenticado
        this.userAuthStatusSubject.next(true);
        this.connectToWebSocket();
      } else {
        this.userAuthStatusSubject.next(false);

      }
    });
  }



  private connectToWebSocket(): void {
    this.currentUser = this.authService.getCurrentUser();
    const user_id = this.currentUser?.idEmp ?? 0;

    this.websocketService.connect(`${this.ruta_ws}/notifications/${user_id}`).subscribe(
    (message: any) => {

        this.handleNewNotification(message);
    },
    (error) => {
        console.error('Error al conectar al WebSocket', error);
        // Implementa lógica para intentar reconectar aquí si lo deseas
        this.connectToWebSocket(); // Reintentar la conexión
    },
    () => {
        console.log('Conexión WebSocket cerrada');
    }
  );

  }



  private handleNewNotification(message: any): void {

    const currentNotifications = this.notificationsSubject.getValue();
    let updatedNotifications = [...currentNotifications];

    if (message && message.type === "update_notification") {
      updatedNotifications = currentNotifications.map(notification =>
        notification.id === message.notificationId ? { ...notification, leida: message.leida } : notification
      );

    } else if (message && message.type === "update_all_notifications") {
      if (message.clear) {
        updatedNotifications = [];
      } else {
        updatedNotifications = currentNotifications.map(notification => ({
          ...notification,
          leida: message.leida
        }));
      }

    } else if (message && message.type === "new_notification") {
      const newNotification = new Notifications(message.data);
      updatedNotifications = [newNotification, ...currentNotifications];
      this.notificationsStateService.setNewNotification(true);

    } else if (message && Array.isArray(message.data)) {
      const newNotifications = message.data.map(
        (log: any) => new Notifications(log)
      );
      updatedNotifications = [...newNotifications, ...currentNotifications];
    } else {
      console.error("Formato inesperado de notificación:", message);
    }

    this.notificationsSubject.next(updatedNotifications);

    this.notificationsStateService.setNotifications(updatedNotifications);

    const hasUnread = updatedNotifications.some(notification => !notification.leida);
    this.notificationsStateService.setNewNotification(hasUnread);
  }




  setNewNotification(status: boolean): void {
    this.newNotificationSubject.next(status);
  }

  setNotifications(notifications: Notifications[]): void {
    this.notificationsSubject.next(notifications);

  }


  updateNotificationReadState(notificationId: number, user_id: number): Observable<Notifications> {
    return this.http.post<Notifications>(`${this.ruta}/marcarLeida`, { notificationId, user_id }).pipe(
      tap(() => {
        // Aquí actualizamos la lista de notificaciones en el frontend
        const currentNotifications = this.notificationsSubject.getValue();

        const updatedNotifications = currentNotifications.filter(notification => notification.id !== notificationId);


        this.notificationsSubject.next(updatedNotifications);
      })
    );
  }

  updateAllNotificationsReadState(user_id: number): Observable<Notifications> {
    return this.http.post<Notifications>(`${this.ruta}/marcarTodasLeidas`, { user_id }).pipe(
      tap(() => {
        // Aquí actualizamos la lista de notificaciones en el frontend
        const currentNotifications = this.notificationsSubject.getValue();
        const updatedNotifications = currentNotifications.map(notification => ({
          ...notification,
          leida: true  // Marcamos todas las notificaciones como leídas
        }));
        this.notificationsSubject.next(updatedNotifications);  // Actualizamos el estado de las notificaciones
        this.notificationsStateService.setNotifications(updatedNotifications);  // También actualizamos el estado en el servicio NotificationsStateService

        // También actualizamos el estado de "nueva notificación" (si no hay notificaciones no leídas)
        const hasUnread = updatedNotifications.some(notification => !notification.leida);
        this.notificationsStateService.setNewNotification(hasUnread);
      })
    );
  }

}
